import _ from 'lodash';

export function currentCompany() {
  return JSON.parse(localStorage.getItem('company'));
}

function publicCompanies() {
  return [];
}

export function currentCompanyId() {
  return _.get(currentCompany(), 'id');
}

export function isPublicCompany() {
  return publicCompanies().includes(currentCompanyId());
}

export function currentCompanyName() {
  return _.get(currentCompany(), 'name');
}

export function currentCompanyLogoUrl() {
  return _.get(currentCompany(), 'logoUrl');
}

export function currentCompanyPresent() {
  return !_.isEmpty(currentCompanyId());
}
